<template>
<div>
  <div :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor">
    <div class="logo">
      <router-link :to="{path: 'home'}" tag="a" class="simple-text logo-normal">
          <img src="/static/img/logo.svg" style="width:200px; margin-left:25px;">
      </router-link>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot>

      </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
      <div class="col-12 text-center sidebar-clock" v-if="localTime">
        {{ $t("at_our_office_the_time") }}
        <div class="time">
          {{ localTime }}
        </div>
        <span v-if="timezone">{{ timezone }}</span>
      </div>
    </div>
  </div>
  <div><socket-listener v-on:ticket-update="ticketUpdated" v-on:file-update="fileUpdated"></socket-listener></div>
  </div>
</template>
<script>
import SocketListener from "../../Dashboard/Views/components/SocketListener.vue";
  export default {
    components: {
      SocketListener
    },
    data: function () {
    return {
        localTime:'',
        timezone: '',
        sidebarLinks: [
            {
              name: this.$t('upload_now'),
              icon: 'fas fa-upload',
              path: '/portal/fileservice/upload'
            },
            {
              name: this.$t('dashboard'),
              icon: 'fas fa-home',
              path: '/portal/home'
            },
            {
              name: this.$t('fileservice'),
              icon: 'fas fa-copy',
              path: '/portal/fileservice'
            },
            {
              name: this.$t('credits'),
              icon: 'fas fa-hand-holding-usd',
              path: '/portal/credits'
            },
            {
              name: this.$t('transactions'),
              icon: 'fas fa-file-invoice-dollar',
              path: '/portal/transactions'
            },
            {
              name: this.$t('support'),
              icon: 'fas fa-question-circle',
              path: '/portal/tickets',
              alert: false
            },
            {
              name: this.$t('vehicle_catalog'),
              icon: 'fas fa-car',
              path: '/portal/vehicle-catalog'
            },
            {
              name: this.$t('price_list'),
              icon: 'fas fa-hand-holding-usd',
              path: '/portal/price-list'
            },
            {
              name: this.$t('logout'),
              icon: 'fas fa-sign-out-alt',
              path: '/logout'
            }
          ]

      }
    },
    props: {
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: '/static/img/favicon.png'
      }
    },
    computed: {
      ws: () => { return Webservice; },
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      ticketUpdated() {
          // Find item index using _.findIndex (thanks @AJ Richardson for comment)
        var index = _.findIndex(this.sidebarLinks, {name: this.$t('support')});

        // Replace item at index using native splice
        this.sidebarLinks.splice(index, 1, {name: this.$t('support'), icon: 'fas fa-question-circle', path: '/portal/tickets', alert: true});
      },
      fileUpdated() {
          // Find item index using _.findIndex (thanks @AJ Richardson for comment)
        var index = _.findIndex(this.sidebarLinks, {name: this.$t('fileservice')});

        // Replace item at index using native splice
        this.sidebarLinks.splice(index, 1, {name: this.$t('fileservice'), icon: 'fas fa-copy', path: '/portal/fileservice', alert: true});
      },
      async initScrollBarAsync () {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      loadLogo() {
        var logo = Ls.get('opts.logo');
        if(logo) {
          this.logo = logo
        }
      },
      loadTimezone() {
        this.timezone = 'Australia/Brisbane'; // FIXED on request by customer

        if(this.timezone) {
          this.localTime = moment().tz(this.timezone).format('H:mm:ss');

          this.$nextTick(function () {
            window.setInterval(() => {
                this.localTime = this.runTime();
            },1000);
        })
        }
      },
      runTime() {
        var localOfficeTime = moment().tz(this.timezone).format('H:mm:ss');
        return localOfficeTime;
      }
    },
    mounted () {
      this.initScrollBarAsync();
      this.loadLogo();
      this.loadTimezone();
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue